<div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
</div>
<div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden tw-bg-gray-100">
  <div class="tw-flex-none tw-bg-grid-layout tw-bg-yellow-100 tw-pt-20 tw-pb-[60px]">
    <div class="tw-font-body tw-font-bold tw-text-600 tw-tracking-normal tw-text-center" i18n="@@myOrders">My orders</div>
  </div>
  <div class="tw-flex-none tw-flex tw-px-6 tw-gap-2 tw-relative tw-z-10 tw-mt-[-20px]">
    <div class="tw-h-10 tw-flex tw-items-center tw-justify-center tw-px-4 tw-rounded-full" [ngClass]="{'tw-bg-white tw-shadow-z1': activeOrderType !== orderType.active, 'tw-bg-black tw-text-white': activeOrderType === orderType.active }" (click)="changeOrderType(orderType.active)">
      <span i18n="@@active">active</span>
    </div>
    <div class="tw-h-10 tw-flex tw-items-center tw-justify-center tw-px-4 tw-rounded-full" [ngClass]="{'tw-bg-white tw-shadow-z1': activeOrderType !== orderType.completed, 'tw-bg-black tw-text-white': activeOrderType === orderType.completed }" (click)="changeOrderType(orderType.completed)">
      <span i18n="@@completed">completed</span>
    </div>
    <div class="tw-h-10 tw-flex tw-items-center tw-justify-center tw-px-4 tw-rounded-full" [ngClass]="{'tw-bg-white tw-shadow-z1': activeOrderType !== orderType.cancelled, 'tw-bg-black tw-text-white': activeOrderType === orderType.cancelled }" (click)="changeOrderType(orderType.cancelled)">
      <span i18n="@@cancelled">cancelled</span>
    </div>
  </div>
  <div class="tw-flex-auto tw-relative tw-overflow-y-auto">
    @if (isLoading) {
      <loading class="pos-abs vh-center"></loading>
    }
    @if (!isLoading) {
      <div class="tw-flex tw-flex-col tw-gap-3 tw-pt-5 tw-px-5 tw-mb-6">
        @if (!orders?.length) {
          <div class="empty-hint centerA empty-icon">
            <span class="tw-font-body tw-text-300" i18n="@@noOrdersAvailable">No orders available</span>
          </div>
        }
        @for (order of orders; track order) {
          <div routerLink="/user/order/{{order?.objectId}}">
            @if (order?.type === appConfig.Shared.Order.Type.REGIMEN && (order?.regimenStateAtLastCheckpoint?.regimenId || order?.regimen?.regimenId)) {
              <div class="tw-rounded-3 tw-p-4 tw-border tw-border-gray-200 tw-shadow-z4 tw-bg-white">
                <div class="tw-flex tw-justify-between tw-mb-5">
                  <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
                    @switch (true) {
                      @case (order.stage === STAGE.INITIAL) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none" i18n="@@orderNotPlacedYet">
                    Order not placed yet
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none">
                          <span i18n="@@orderNumber">Order number</span><span>: {{'#'+order.orderNumber}}</span>
                        </p>
                      }
                    }
                    @switch (true) {
                      @case (orderPaymentPendingStages.includes(order.stage)) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      }
                      @case (!!orderMap.get(order.objectId)?.expectedDeliveryDate?.to) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{orderMap.get(order.objectId)?.expectedDeliveryDate?.to | date: 'd MMM'}}</span>
                        </p>
                      }
                      @case (showDeliverOnDate(order)) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{ order.deliverOnDate.iso | date:'dd MM' }}</span>
                        </p>
                      }
                      @case (showDeliveredOn(order)) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@deliveredOn">Delivered on</span><span>: {{ order.deliveredOn | date:'dd MMM yyyy' }}</span>
                        </p>
                      }
                      @case (orderCanceledStages.includes(order.stage) && !order.canceledByUser) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@placeANewOrder">
                    Place a new order
                  </p>
                      }
                      @case (showUserCancelled(order)) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@userCancelled">
                    User cancelled
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          -
                        </p>
                      }
                    }
                  </div>
                  @switch (true) {
                    @case (orderPaymentPendingStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-yellow-400 tw-bg-yellow-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      </div>
                    }
                    @case (orderPlacedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@orderPlaced">
                    Order placed
                  </p>
                      </div>
                    }
                    @case (orderPackedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@packed">
                    Packed
                  </p>
                      </div>
                    }
                    @case (orderDispatchedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@dispatched">
                    Dispatched
                  </p>
                      </div>
                    }
                    @case (orderOutForDeliveryStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-red-400 tw-bg-red-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@outForDelivery">
                    Out For Delivery
                  </p>
                      </div>
                    }
                    @case (orderDeliveryFailedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@deliveryAttemptFailed">
                    Delivery attempt failed
                  </p>
                      </div>
                    }
                    @case (orderDeliveredStages.includes(order.stage)) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@delivered">Delivered</p>
                        <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                        </div>
                      </div>
                    }
                    @case (isCurrentOrderInRefundStages(order?.objectId) && (orderCanceledStages.includes(order.stage) || order.stage === appConfig.Shared.Order.Stage.REFUND_INITIATED)) {
                      @if (refundRelatedStageOrdersMap.get(order?.objectId)?.stage === STAGE.REFUND_PROCESSED) {
                        <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                          <p class="tw-font-body tw-text-200 tw-text-black">Refunded</p>
                          <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                            <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                          </div>
                        </div>
                      } @else {
                        <ng-container *ngTemplateOutlet="greenTag; context: { $implicit: REFUND_STAGE_LABEL[refundRelatedStageOrdersMap.get(order?.objectId)?.stage] }"></ng-container>
                      }
                    }
                    @case (orderReturnStages.includes(order.stage)) {
                      <ng-container *ngTemplateOutlet="greenTag; context: { $implicit: RETURN_STAGE_LABEL[order.stage] }"></ng-container>
                    }
                    @case (!isCurrentOrderInRefundStages(order?.objectId) && orderCanceledStages.includes(order.stage)) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto" i18n="@@canceled">
                    Cancelled
                  </p>
                        <div class="tw-rounded-full tw-bg-red-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'close'"></cs-icon>
                        </div>
                      </div>
                    }
                    @default {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1 tw-bg-gray-100 tw-border tw-border-gray-300 tw-px-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto">
                          {{order.stage.replace('_', ' ') | titlecase}}
                        </p>
                      </div>
                    }
                  }
                </div>
                <div class="tw-flex tw-items-center tw-gap-4">
                  <div>
                    <div class="tw-w-32 tw-h-[120px] tw-rounded-3" [ngClass]="getRegimenPaletteForOrder(order).background100">
                      <img [src]="order.regimenStateAtLastCheckpoint?.regimenCoverImage || order.regimen?.regimenCoverImage" class="tw-w-32 tw-h-[120px] tw-object-cover tw-rounded-3" alt="regimen_img"/>
                    </div>
                  </div>
                  <div>
                    <div class="tw-flex tw-flex-col tw-gap-2">
                      @if (order.regimenStateAtLastCheckpoint?.displayConcern?.name || order?.regimen?.displayConcern?.name) {
                        <p class="tw-text-400 tw-font-body tw-font-bold tw-text-black">
                          <span i18n="@@treatmentKitForConcern">
                            Treatment <br/> Kit for <span class="tw-capitalize">{{order.regimenStateAtLastCheckpoint?.displayConcern?.name || order?.regimen?.displayConcern?.name}}</span>
                          </span>
                        </p>
                      }
                      @if (!(order.regimenStateAtLastCheckpoint?.displayConcern?.name || order?.regimen?.displayConcern?.name)) {
                        <p class="tw-text-400 tw-font-body tw-font-bold tw-text-black">
                          @if (order.regimenStateAtLastCheckpoint?.class === appConfig.Shared.InstantCheckup.Type.FACE || order.regimen?.class === appConfig.Shared.InstantCheckup.Type.FACE) {
                            <span>
                              Treatment <br/> Kit for <span class="tw-capitalize">{{appConfig.Shared.RegimenFor.SKIN.toLowerCase()}} </span>
                            </span>
                          }
                          @if ((order.regimenStateAtLastCheckpoint?.class && order.regimenStateAtLastCheckpoint?.class !== appConfig.Shared.InstantCheckup.Type.FACE) || order.regimen?.class !== appConfig.Shared.InstantCheckup.Type.FACE) {
                            <span>
                              Treatment <br/> Kit for <span class="tw-capitalize">{{order.regimenStateAtLastCheckpoint?.class?.toLowerCase() || order.regimen?.class?.toLowerCase()}} </span>
                            </span>
                          }
                        </p>
                      }
                    </div>
                    @if (getFreeProductDetails(order)) {
                      <div class="tw-mt-2">
                        <p class="tw-text-200 tw-font-body tw-text-gray-800"> + Free Pouch </p>
                      </div>
                    }
                  </div>
                </div>
                @switch (true) {
                  @case (orderPaymentPendingStages.includes(order.stage)) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <span class="tw-w-max tw-max-w-[90%] tw-bg-teal-600 tw-text-white tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden tw-capitalize tw-py-2 tw-px-4" i18n="@@makePayment"> Make payment </span>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.stage) && order.paymentType === PAYMENT_TYPE.COD) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <div class="tw-flex tw-flex-col">
                        <p class="tw-font-body tw-text-300">
                          <span class="tw-text-black" i18n="@@amountToBePaid">Amount to be paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.amount}}</span>
                        </p>
                        @if (order.paymentType === PAYMENT_TYPE.COD) {
                          <p class="tw-font-body tw-text-300">
                            (Cash on delivery)
                          </p>
                        }
                      </div>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.stage) && order.paymentType !== PAYMENT_TYPE.COD) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.amount}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (orderDeliveredStages.includes(order.stage)) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.amount}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @default {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@orderAmount">Order amount</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order?.regimenStateAtLastCheckpoint?.fixedPrice || order?.regimen?.fixedPrice}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                }
              </div>
            }
            @if (order?.type !== appConfig.Shared.Order.Type.REGIMEN && !!!order?.regimen) {
              <div class="tw-rounded-2xl tw-p-4 tw-border tw-border-gray-200 tw-shadow-z1 tw-bg-white">
                <div class="tw-flex tw-justify-between tw-mb-4">
                  <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
                    @switch (true) {
                      @case (order.stage === STAGE.INITIAL) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none" i18n="@@orderNotPlacedYet">
                    Order not placed yet
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none">
                          <span i18n="@@orderNumber">Order number</span><span>: {{'#'+order.orderNumber}}</span>
                        </p>
                      }
                    }
                    @switch (true) {
                      @case (orderPaymentPendingStages.includes(order.stage)) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      }
                      @case (!!orderMap.get(order.objectId)?.expectedDeliveryDate?.to) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{orderMap.get(order.objectId)?.expectedDeliveryDate?.to | date: 'd MMM'}}</span>
                        </p>
                      }
                      @case (showDeliverOnDate(order)) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{ order.deliverOnDate.iso | date:'dd MM' }}</span>
                        </p>
                      }
                      @case (showDeliveredOn(order)) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@deliveredOn">Delivered on</span><span>: {{ order.deliveredOn | date:'dd MMM yyyy' }}</span>
                        </p>
                      }
                      @case (orderCanceledStages.includes(order.stage) && !order.canceledByUser) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@placeANewOrder">
                    Place a new order
                  </p>
                      }
                      @case (orderCanceledStages.includes(order.stage) && !!order.canceledByUser) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@userCancelled">
                    User cancelled
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          -
                        </p>
                      }
                    }
                  </div>
                  @switch (true) {
                    @case (orderPaymentPendingStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-yellow-400 tw-bg-yellow-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      </div>
                    }
                    @case (orderPlacedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@orderPlaced">
                    Order placed
                  </p>
                      </div>
                    }
                    @case (orderPackedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (orderMap.get(order.objectId)?.shouldShowProductCancellationUI) {
                            <span>{{order.products.length}}/{{orderMap.get(order.objectId).cancelledProducts.length + order.products.length}} </span>
                          }
                          <span i18n="@@packed">
                      Packed
                    </span>
                        </p>
                      </div>
                    }
                    @case (orderDispatchedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (orderMap.get(order.objectId)?.shouldShowProductCancellationUI) {
                            <span>{{order.products.length}}/{{orderMap.get(order.objectId).cancelledProducts.length + order.products.length}} </span>
                          }
                          <span i18n="@@shipped">Shipped</span>
                        </p>
                      </div>
                    }
                    @case (orderOutForDeliveryStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-red-400 tw-bg-red-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (orderMap.get(order.objectId)?.shouldShowProductCancellationUI) {
                            <span>{{order.products.length}}/{{orderMap.get(order.objectId).cancelledProducts.length + order.products.length}} </span>
                          }
                          <span i18n="@@outForDelivery">
                      Out For Delivery
                    </span>
                        </p>
                      </div>
                    }
                    @case (orderDeliveryFailedStages.includes(order.stage)) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (orderMap.get(order.objectId)?.shouldShowProductCancellationUI) {
                            <span>{{order.products.length}}/{{orderMap.get(order.objectId).cancelledProducts.length + order.products.length}} </span>
                          }
                          <span i18n="@@deliveryAttemptFailed">
                      Delivery attempt failed
                    </span>
                        </p>
                      </div>
                    }
                    @case (orderDeliveredStages.includes(order.stage)) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        @if (orderMap.get(order.objectId)?.shouldShowProductCancellationUI) {
                          <span class="tw-font-body tw-text-200 tw-text-black">{{order.products.length}}/{{orderMap.get(order.objectId).cancelledProducts.length + order.products.length}} </span>
                        }
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@delivered">Delivered</p>
                        <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                        </div>
                      </div>
                    }
                    @case (isCurrentOrderInRefundStages(order?.objectId) && (orderCanceledStages.includes(order.stage) || order.stage === appConfig.Shared.Order.Stage.REFUND_INITIATED)) {
                      @if (refundRelatedStageOrdersMap.get(order?.objectId)?.stage === STAGE.REFUND_PROCESSED) {
                        <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                          <p class="tw-font-body tw-text-200 tw-text-black">Refunded</p>
                          <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                            <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                          </div>
                        </div>
                      } @else {
                        <ng-container *ngTemplateOutlet="greenTag; context: { $implicit: REFUND_STAGE_LABEL[refundRelatedStageOrdersMap.get(order?.objectId)?.stage] }"></ng-container>
                      }
                    }
                    @case (orderReturnStages.includes(order.stage)) {
                      <ng-container *ngTemplateOutlet="greenTag; context: { $implicit: RETURN_STAGE_LABEL[order.stage] }"></ng-container>
                    }
                    @case (!isCurrentOrderInRefundStages(order?.objectId) && orderCanceledStages.includes(order.stage)) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto" i18n="@@canceled">
                    Cancelled
                  </p>
                        <div class="tw-rounded-full tw-bg-red-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'close'"></cs-icon>
                        </div>
                      </div>
                    }
                    @default {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1 tw-bg-gray-100 tw-border tw-border-gray-300 tw-px-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto">
                          {{order.stage.replace('_', ' ') | titlecase}}
                        </p>
                      </div>
                    }
                  }
                </div>
                <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-2">
                  @if (!orderMap.get(order.objectId)?.shouldHideProductDetails) {
                    @for (productData of orderMap.get(order.objectId).products; track productData) {
                      <div class="tw-flex tw-items-center tw-gap-2">
                        <img class="tw-h-auto tw-max-h-10 tw-max-w-auto" [src]="productData?.image" />
                        <p class="tw-font-body tw-text-300">{{productData?.quantity}}</p>
                        <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-800" [iconName]='"close"'></cs-icon>
                        <p class="tw-font-body tw-text-300">{{productData.product.title}}</p>
                      </div>
                    }
                  }
                  @if (orderMap.get(order.objectId)?.shouldShowProductCancellationUI) {
                    @for (product of orderMap.get(order.objectId)?.cancelledProducts; track product) {
                      <div class="tw-flex tw-items-center tw-gap-2">
                        <img class="tw-h-auto tw-max-h-10 tw-max-w-auto" [src]="product?.imageUrl" alt="productImage"/>
                        <div class="tw-opacity-[0.4]">
                          <div class="tw-flex tw-items-center tw-gap-2">
                            <p class="tw-font-body tw-text-300">{{product?.quantity}}</p>
                            <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-800" [iconName]='"close"'></cs-icon>
                            <p class="tw-font-body tw-text-300">{{product?.title}}</p>
                          </div>
                          <p class="tw-text-100 tw-text-orange-500" i18n="@@removedByYourDoctor">Removed by your doctor</p>
                        </div>
                      </div>
                    }
                  }
                </div>
                @switch (true) {
                  @case (orderPaymentPendingStages.includes(order.stage)) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <span class="tw-w-max tw-max-w-[90%] tw-bg-teal-600 tw-text-white tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden tw-capitalize tw-py-2 tw-px-4" i18n="@@makePayment"> Make payment </span>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.stage) && order.paymentType === PAYMENT_TYPE.COD) {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <div class="tw-flex tw-flex-col">
                        <p class="tw-font-body tw-text-300">
                          <span class="tw-text-black" i18n="@@amountToBePaid">Amount to be paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.amount}}</span>
                        </p>
                        @if (order.paymentType === PAYMENT_TYPE.COD) {
                          <p class="tw-font-body tw-text-300">
                            (Cash on delivery)
                          </p>
                        }
                      </div>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.stage) && order.paymentType !== PAYMENT_TYPE.COD) {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.amount}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (orderDeliveredStages.includes(order.stage)) {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.amount}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @default {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@orderAmount">Order amount</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.amount}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<ng-template #greenTag let-label>
  <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
    <p class="tw-font-body tw-text-200 tw-text-black">{{ label }}</p>
  </div>
</ng-template>
